<template>
  <div ref="root" style="position: relative;">
    <div class="analysis-section-title button-row d-flex justify-space-between align-center">
      <div class="d-flex">
        <span>
          {{ title }}
        </span>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="grey"
              v-bind="attrs"
              v-on="on"
              size="18px"
              class="pl-1"
            >
              info_outlined
            </v-icon>
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </div>
      <v-btn
        v-if="!readOnly"
        text
        color="#3C44C8"
        class="buttons px-2"
        :input-value="currentlyAddingTextElement"
        @click="addNewElement"
      >
        + {{ $t('actions.add') }}
      </v-btn>
    </div>
    <v-expand-transition>
      <div v-if="currentlyAddingTextElement">
        <TextInput
          ref="textInput"
          class="mr-6 mb-6 mt-2"
          leave-room-for-code="44px"
          @save="saveNewTextElement"
          @cancel="cancelNewTextElement"
        />
      </div>
    </v-expand-transition>
    <CodeSVG
      v-if="currentlyAddingTextElement && showCodeSVG"
      class="codeWidget"
      style="width: 50px;"
      @newSelection="codeClassificationSelection"
    />
    <slot name="input" />
  </div>
</template>
<script>
import TextInput from './mission/TextInput';
import CodeSVG from '../code/CodeSVG';

export default {
  name: 'AnalysisActions',
  components: { TextInput, CodeSVG },
  props: {
    type: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      currentlyAddingTextElement: false,
      codeClassification: '',
      showCodeSVG: false,
    };
  },
  computed: {
    comment() {
      return this.type === 'comment';
    },
    significantElement() {
      return this.type === 'highlight';
    },
    mission() {
      return this.type === 'mission';
    },
    title() {
      if (this.comment) return this.$t('extension.userAnalyses.comments.title');
      if (this.significantElement) return this.$t('extension.userAnalyses.highlights.title');
      if (this.mission) return this.$t('extension.userAnalyses.missions.title');
      throw new Error('Unhandled element type');
    },
    tooltip() {
      if (this.comment) return this.$t('extension.userAnalyses.comments.tooltip');
      if (this.significantElement) {
        return this.$t('extension.userAnalyses.highlights.tooltip');
      }
      if (this.mission) return this.$t('extension.userAnalyses.missions.tooltip');
      throw new Error('Unhandled element type');
    },
  },
  methods: {
    addNewElement() {
      if (this.comment) {
        this.showCodeSVG = false;
        this.currentlyAddingTextElement = !this.currentlyAddingTextElement;
        if (this.currentlyAddingTextElement) {
          this.$nextTick(() => this.$refs.textInput.$refs.textArea.focus());
          setTimeout(() => { this.showCodeSVG = true; }, 300);
        }
        return;
      }
      if (this.significantElement) {
        this.$emit('addNewElement', {
          content: '',
          type: 'highlight',
          codeClassification: this.codeClassification,
        });
        return;
      }
      if (this.mission) {
        this.$emit('addNewElement', {
          content: '',
          type: 'mission',
        });
        return;
      }
      throw new Error('Unhandled element type');
    },
    cancelNewTextElement() {
      this.currentlyAddingTextElement = false;
      this.showCodeSVG = false;
    },
    saveNewTextElement(content) {
      console.log('saveNewTextElement', content);
      this.$emit('addNewElement', {
        ...content,
        type: 'comment',
        codeClassification: this.codeClassification,
      });
      this.currentlyAddingTextElement = false;
      this.showCodeSVG = false;
    },
    codeClassificationSelection(newClassification) {
      console.log('selection!! : ', newClassification);
      this.codeClassification = newClassification;
    },
  },
  mounted() {
    const el = this.$refs.root;
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
      { threshold: [1] },
    );
    observer.observe(el);
  },
};
</script>
<style scoped>
.buttons {
  font-size: 12px;
  font-weight: 500;
}
.newAnalysisComment {
  flex-grow: 1;
  position: relative;
}
.codeWidget {
  position: absolute;
  right: 32px;
  top: 68px;
}

.button-row {
  margin-right: 24px;
  height: 32px;
}
</style>
